export default __webpack_public_path__ + "static/media/TheEvent.d917dc0a.PNG";